// Graph QL Query
// ==============
const defaultHeaders = {
  'Content-Type': 'application/graphql',
  'X-Shopify-Storefront-Access-Token': `${process.env.STOREFRONT_API_TOKEN}`,
};
export function MakeGraphQLQuery(url, query, headers = defaultHeaders) {
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: query,
  }).then((response) => response.json());
}

// Search URL Params
// =================
export function URLParams(name) {
  var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
    // existingParams = results
    // return existingParams;
  }
}

// Update Dropdown Select
// ======================
export function updateDropdownSelectedValue(name, value) {
  // Updated Hidden Select Field For Product Form JS
  $('option:selected', `select[name="${name}"]`).removeAttr('selected');
  $(`option[value="${value}"]`, `select[name="${name}"]`).prop(
    'selected',
    true
  );

  $(`select[name="${name}"]`).next('.nice-select').find('.current').text(value);
  $(`select[name="${name}"]`)
    .next('.nice-select')
    .find('.option')
    .removeClass('selected');
  $(`select[name="${name}"]`)
    .next('.nice-select')
    .find(`.option[data-value="${value}"]`)
    .addClass('selected');
}

// Check Browser Size
// ==================
export function isMobile() {
  if ($('body').width() <= 1199) {
    return true;
  }
  return false;
}

export function isSliderMenu() {
  if ($('body').width() <= 1199) {
    return true;
  }
  return false;
}

// Creating Cookies
// ================
export function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = '; expires=' + date.toGMTString();
  } else var expires = '';
  document.cookie = name + '=' + value + expires + '; path=/';
}

export function readCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name) {
  createCookie(name, '', -1);
}

// Google Analytics and
// Google Tag Manager
// ====================
// Strategist Request that Product Titles are
// sorted Alphabetically and the Array be a
// single comma separated string
// ====================
export function setGTMcompareProductsEvent(products = [], location = '') {
  let productTitles = products.sort().join(', ');
  dataLayer.push({
    event: 'compareAdd',
    productName: productTitles,
    compareLocation: location,
  });
}

export function setGTMdataLayerEvents(type, dataVariable = [], location = '') {
  let productTitles;
  switch (type) {
    case 'sample-products':
      productTitles = dataVariable.sort().join(', ');
      dataLayer.push({
        event: 'sampleProducts',
        sampleProducts: productTitles,
      });
      break;
    case 'sample-add':
      productTitles = dataVariable.sort().join(', ');
      dataLayer.push({
        event: 'sampleAdd',
        productName: productTitles,
        sampleLocation: location,
      });
      break;
    case 'for-who':
      let customerType = dataVariable
        .toString()
        .replace('M', 'Male')
        .replace('F', 'Female');
      if (!customerType.includes('Carer')) {
        customerType = `Consumer ${customerType}`;
      }
      dataLayer.push({
        event: 'sampleGender',
        sampleForWho: customerType,
      });
      break;
  }
}

export function setGTMquickShopAdd(productTitle, source = '') {
  const eventData = {
    event: 'quickAdd',
    productName: productTitle,
  };

  // Add source information if provided
  if (source) {
    eventData.source = source;
    eventData.feature =
      source === 'cross-sell-panel' ? 'Cross-Sell Panel'
       : source === 'cross-sell-cart-drawer' ? 'Cross-Sell Cart Drawer'
       : source === 'cross-sell-cart-page' ? 'Cross-Sell Cart Page'
       : 'Quick Shop';
  }

  dataLayer.push(eventData);
}

// Slick JS Helper Functions
// ==========================
export function updateSliderArrowAppearance(
  arrowType,
  $this,
  slick,
  currentSlide
) {
  let arrowClass;
  if (arrowType == 'next-arrow') {
    arrowClass = `.slick-next.slick-arrow`;
  } else if (arrowType == 'prev-arrow') {
    arrowClass = `.slick-prev.slick-arrow`;
  } else {
    return;
  }

  if (
    arrowType == 'next-arrow' &&
    slick.$slides.length == currentSlide + slick.options.slidesToShow
  ) {
    $this.find(`${arrowClass}`).addClass('fade-out');
  } else if (arrowType == 'prev-arrow' && currentSlide < 1) {
    $this.find(`${arrowClass}`).addClass('fade-out');
  } else {
    if ($this.find(`${arrowClass}`).hasClass('fade-out')) {
      $this.find(`${arrowClass}`).removeClass('fade-out');
    }
  }
}

// Capatalise String
// =================
export const CapitalizeString = (firstName) =>
  firstName.charAt(0).toUpperCase() + firstName.slice(1);

// Compare Product Helper function
// ===============================
export const checkProductIsInCompareArray = (arr, handle) =>
  arr.some((item) => item.handle === handle);

// Set Product Absorbency Droplet Rating
// =====================================
export function setProductAbsorbencyDropRating(tags) {
  if (!tags) return;

  let rating = '0';
  let baseAssetUrl = window.Shopify.assetBaseUrl;
  let halfDropSVG = 'ui-icon-drip-half.svg';
  let fullDropSVG = 'ui-icon-drip-full.svg';
  let emptyDropSVG = 'ui-icon-drip-empty.svg';
  let ratingHTML = '';

  // Loop over the Tags to collection the Absorbency Value
  tags
    .filter((tag) => tag.includes('absorbency_rating:'))
    .map((tag) => {
      let val = tag.split(':');
      rating = val[1].toString();
    });

  // Loop over the Droplets and Append Appropriate Img
  for (let $i = 0; $i < 8; $i++) {
    let halfDrop = $i + 0.5;
    if (parseFloat(rating) == halfDrop) {
      ratingHTML += `<img class="drop-rating__icon" src="${
        baseAssetUrl + halfDropSVG
      }">`;
    } else if (parseFloat(rating) >= $i) {
      ratingHTML += `<img class="drop-rating__icon" src="${
        baseAssetUrl + fullDropSVG
      }">`;
    } else {
      ratingHTML += `<img class="drop-rating__icon" src="${
        baseAssetUrl + emptyDropSVG
      }">`;
    }
  }

  // Return The Rating
  return ratingHTML;
}

// Set Product Badge within Product Card
// =====================================
export function setProductCardBadge(data) {
  if (!data) return;
  let html = '';
  let hasFlag = false;
  let flagType = '';
  let flagLabel = '';
  let flagClassName = '';
  let onSale = false;

  if (data.compareAtPrice !== null && data.price !== null) {
    onSale = data.compareAtPrice.amount > data.price.amount; // Check a product is on sale
  }

  // Sale Tag take precedence over the tags themselves
  if (onSale) {
    hasFlag = true;
    flagLabel = 'Sale';
    flagClassName = 'sale';
  } else {
    for (let i = 0; i < data['tags'].length; i++) {
      let tagHandle = data['tags'][i];
      if (tagHandle.match('^badge')) {
        hasFlag = true;
        flagType = tagHandle.split('badge:');
        flagLabel = flagType[1];
        flagClassName = flagType[1].toLowerCase().replace(' ', '-');
        // Set order of priority and break loop
        if (
          flagClassName === 'sale' ||
          flagClassName === 'best-seller' ||
          flagClassName === 'new'
        ) {
          break;
        }
      }
    }
  }

  if (hasFlag && flagLabel) {
    html = `<span class="prod-card__banner-badge prod-card__banner-badge--${flagClassName}">${flagLabel}</span>
            <span class="prod-card__banner-background prod-card__banner-background--${flagClassName}"></span> `;
  }
  return html;
}

// Get Scrollbar Width in Present
// ===================
// ref: https://stackoverflow.com/a/13382873/1240061
export function getScrollbarWidthPresent() {
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll"; // forcing scrollbar to appear
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement("div");
  outer.appendChild(inner);

  // Check if scrollbar is present on body
  const scrollbarPresent = document.documentElement.scrollHeight > document.documentElement.clientHeight 

  // Initializing scrollbar width
  let scrollbarWidth = 0;

  // Where there is scrollbar
  if (scrollbarPresent) {
    // Calculating difference between container's full width and the child width
    scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  }

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}

export const toSnakeCase = str =>
      str &&
      str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.toLowerCase())
        .join('_');

// Add debounce if not already defined
export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export const slickHelpers = {
  handleResponsiveSlider($slider, breakpoint) {
    const handleResize = debounce(() => {
      // Only check if:
      // 1. Window is larger than breakpoint
      // 2. Slider is currently unslicked
      if (window.innerWidth >= breakpoint && !$slider.hasClass('slick-initialized')) {
        // console.log('Initializing slider');
        $slider.slick('init');
      }
    }, 300);

    $(window).on('resize', handleResize);
  }
};

export function getImageFilenameWithoutExtension(url) {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    const filename = pathname.substring(pathname.lastIndexOf('/') + 1);
    const withoutExtension = filename.substring(0, filename.lastIndexOf('.')) || filename;
    return withoutExtension;
  } catch (e) {
    console.error("Invalid URL:", e);
    return null;
  }
}